<template>
  <div class="page-header header-filter" style="background-image: url('img/bg32.jpg')">
    <!-- <div class="page-header-image"
             style="background-image: url('img/login.jpg')">
    </div>-->
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="mr-auto">
              <!-- <img v-lazy="'img/now-logo.png'" alt=""> -->
              <h4 class="title no-top">Solicitud para restablecer la contraseña</h4>
              <p>Escriba su usuario a continuación y le enviaremos las instrucciones de restablecimiento de contraseña</p>
            </div>

            <fg-input
              v-model="form.userName"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons users_circle-08"
              placeholder="Nombre de usuario"
            ></fg-input>
            <vue-recaptcha :sitekey="captchaKey" @verify="onVerify" v-show="!verified"></vue-recaptcha>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <a
                  @click="handleOnClick()"
                  class="btn btn-primary btn-round btn-lg btn-block"
                >Enviar correo de recuperación ></a>
              </div>
              <div class="pull-left">
                <!-- <h6>
                  <a href="#pablo" class="link footer-link">Crear Cuenta</a>
                </h6>-->
              </div>
              <!-- <div class="pull-right">
                <h6>
                  <a href="#recuperar" class="link footer-link">Recuperar Contraseña</a>
                </h6>
              </div>-->
            </template>
          </card>
        </div>
      </div>
    </div>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from "@/components";
import { Select, Option } from "element-ui";
import * as authService from "../../services/AuthService";
//   import MainFooter from '@/layout/MainFooter';
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    "vue-recaptcha": VueRecaptcha,
    Card,
    //   MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
      verified: false,
      form: {
        firstName: "",
        email: "",
        phone: "",
        userName: "",
        password: ""
      }
    };
  },
  methods: {
    onVerify: function(response) {
      this.verified = true;
    },
    handleOnClick: function() {
      if (!this.form.userName) {
        this.$noty.error("El nombre de usuario es obligatorio.");
        return;
      }

      if (this.verified) {
        authService.resetPrestador(
          this.$osapm(),
          this.form.userName,
          success => this.$noty.success(success),
          error => this.$noty.error(error)
        );
      } else {
        this.$noty.error("Debe resolver el captcha");
      }
    }
  }
};
</script>

<style scoped>
h4.no-top {
  margin-top: 0%;
  padding-top: 0%;
}

div.content {
  margin-top: 8% !important;
}

.login-page .card-login .input-group:last-child {
  margin-bottom: 0;
}
</style>